module.exports = __webpack_public_path__ + "img/TechGatherFarm2_ua.ce401edf.webp";